<script setup lang="ts">
import type { ConditionFormData } from "@/components/form"
import Pdf from "@/components/Pdf.vue"
import type { StaffSignContractTask } from "@/model/staff/staff-sign-contract-task"
import SignStaffPrimaryContract from "@/pages/Tasks/Tasks/Staff/SignStaffPrimaryContract.vue"
import type { TasksProps } from "@/pages/Tasks/Tasks/tasks-props"
import { useHttpClient } from "@/vf"
import { ref } from "vue"

const props = defineProps<TasksProps<StaffSignContractTask>>()
const emit = defineEmits<{
    (e: "updated"): void
}>()

const http = useHttpClient()

async function signed(form: FormData) {
    await http.post(`/staff-member/contract/${props.task.id}/upload`, form)
    emit("updated")
}

// predefined fields that are already known in the pdf and should not shown again
const model = (await http.get<ConditionFormData>(`/staff-member/contract/${props.task.id}/form-data`)).data

// we can't hide the pre provided fields, because they won't will be included in the final pdf for some reason and
// its fine for the moment to just include the field.
const preProvidedFields: string[] = []
// const preProvidedFields = Object.keys(model).filter(key => model[key] !== "")

const modelValue = ref(model)
</script>

<template>
    <div class="bg-white p-4" v-if="viewMode === 'customer'">
        <div class="mt-3">
            <pdf :file="`/staff-member/contract/${props.task.id}/pdf`"></pdf>
        </div>
        <template v-if="props.task.state == 'open'">
            <SignStaffPrimaryContract
                v-model="modelValue"
                :pre-provided-fields="preProvidedFields"
                @signed="signed"
            ></SignStaffPrimaryContract>
        </template>
    </div>
</template>
